import React, { useState, useEffect, useRef } from "react";
import logo from "../assets/logo.png";
import { useAuth } from "../utils/authentication";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";

function LoginPage() {
    const [error, setError] = useState("");
    const { isAuthenticated, login } = useAuth();
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();

    const logoRef = useRef(null);
    const [logoWidth, setLogoWidth] = useState(0);

    useEffect(() => {
        if (logoRef.current) {
            setLogoWidth(logoRef.current.offsetWidth);
        }

        if (isAuthenticated) {
            navigate("/chat");
        }
    }, [isAuthenticated, navigate]);

    const handleGoogleLogin = async (response) => {
        const { credential } = response;

        try {
            const res = await fetch(`${apiUrl}/google-login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ token: credential }),
            });

            const data = await res.json();
            if (res.ok) {
                setError("");
                localStorage.setItem("userId", data.email);
                login();
            } else {
                setError("Login failed. Please contact admin.");
            }
        } catch (err) {
            setError("Login failed. Please contact admin.");
        }
    };

    return (
        <div className="min-h-screen bg-white dark:bg-black transition-all duration-500">
            <div className="container mx-auto px-4 h-screen flex flex-col justify-center items-center">
                <div className="bg-white dark:bg-black border border-gray-300 dark:border-gray-700 shadow-lg rounded-2xl p-8 w-full max-w-md flex flex-col items-center">
                    <img
                        className="h-16 mx-auto mb-8"
                        ref={logoRef}
                        src={logo}
                        alt="I-Stem Agent Logo"
                    />
                    <h1 className="text-2xl font-medium text-black dark:text-white text-center mb-8">
                        Welcome to the I-Stem Agent
                        {/* Some tagline here */}
                    </h1>
                    <div className="w-full flex justify-center">
                        <GoogleLogin
                            className="w-full"
                            onSuccess={handleGoogleLogin}
                            onError={(error) =>
                                setError("Google Login failed. Please try again.")
                            }
                            useOneTap
                            theme="outline"
                            width={logoWidth}
                        />
                    </div>
                </div>
                {error && (
                    <p
                        className="text-sm text-red-500 dark:text-red-400 mt-4 text-center"
                        role="alert"
                    >
                        {error}
                    </p>
                )}
            </div>
        </div>
    );
}

export default LoginPage;
